import type { FrontModule } from "@core/modules";
import { useGet } from "@core/hooks";
import { Card } from "@core/ui";
import { CriteresTab } from "./campaign";
import { MesPieces } from "./candidate";
import { ControlesTab, PiecesTab, RapportTab, RevenusTab, SyntheseTab } from "./landlord";
import { QualitePage } from "./quality";
import "./controle.css";

// Module « controle » : collecte adaptée, complétude, lecture sourcée, cohérence, métadonnées, avis fiscal,
// 2D-DOC, contrat de travail, employeur, revenus, critères, trois résultats distincts, rapport, qualité.

function Dashboard({ orgId }: { orgId: string }) {
  const q = useGet<{ analysees: number; avec_pieces_manquantes: number; avec_constats_a_examiner: number }>(`/api/v1/orgs/${orgId}/controles/apercu`);
  if (!q.data || q.data.analysees === 0) return null;
  const d = q.data;
  return (
    <Card title="Contrôles des dossiers">
      <div className="stats">
        <div className="stat">
          <span className="stat-label">Dossiers analysés</span>
          <span className="stat-value num">{d.analysees}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Avec des pièces manquantes</span>
          <span className="stat-value num">{d.avec_pieces_manquantes}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Avec des constats à examiner</span>
          <span className="stat-value num">{d.avec_constats_a_examiner}</span>
        </div>
      </div>
      <p className="small muted">Constats à examiner : anomalies détectées et points à confirmer. Chaque constat indique sa source ; vous décidez.</p>
    </Card>
  );
}

export const module: FrontModule = {
  name: "controle",
  orgRoutes: [{ path: "qualite-des-controles", element: <QualitePage /> }],
  nav: [{ to: "qualite-des-controles", label: "Qualité des contrôles", section: "Location", perm: "members", order: 40, hideWhenRestricted: true }],
  Dashboard,
  applicationTabs: [
    { id: "controle-synthese", label: "Synthèse", order: 20, Component: SyntheseTab },
    { id: "controle-pieces", label: "Pièces", order: 21, Component: PiecesTab },
    { id: "controle-controles", label: "Contrôles", order: 22, Component: ControlesTab },
    { id: "controle-revenus", label: "Revenus", order: 23, Component: RevenusTab },
    { id: "controle-rapport", label: "Rapport", order: 24, Component: RapportTab },
  ],
  candidateSections: [{ id: "controle-mes-pieces", label: "Mes pièces", order: 20, Component: MesPieces }],
  campaignTabs: [{ id: "controle-criteres", label: "Critères", order: 30, Component: CriteresTab }],
};
